// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/antd/dist/antd.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-100: rgb(11, 71, 254);
  --primary-90: rgba(11, 71, 254, 90%);
  --primary-80: rgba(11, 71, 254, 80%);
  --primary-70: rgba(11, 71, 254, 70%);
  --primary-60: rgba(11, 71, 254, 60%);
  --primary-50: rgba(11, 71, 254, 50%);
  --primary-40: rgba(11, 71, 254, 40%);
  --primary-30: rgba(11, 71, 254, 30%);
  --primary-20: rgba(11, 71, 254, 20%);
  --primary-10: rgba(11, 71, 254, 10%);
  --primary-05: rgba(11, 71, 254, 5%);
  --secondary-100: rgb(53, 0, 183);
  --secondary-90: rgba(53, 0, 183, 90%);
  --secondary-80: rgba(53, 0, 183, 80%);
  --secondary-70: rgba(53, 0, 183, 70%);
  --secondary-60: rgba(53, 0, 183, 60%);
  --secondary-50: rgba(53, 0, 183, 50%);
  --secondary-40: rgba(53, 0, 183, 40%);
  --secondary-30: rgba(53, 0, 183, 30%);
  --secondary-20: rgba(53, 0, 183, 20%);
  --secondary-10: rgba(53, 0, 183, 10%);
  --secondary-05: rgba(53, 0, 183, 5%);
  --white: #ffffff;
  --white-80: rgba(255, 255, 255, 0.8);
  --white-60: rgba(255, 255, 255, 0.6);
  --black: #000000;
  --black-10: #525252;
  --text-1: #1a1a1a;
  --text-2: #a1a1a1;
  --grey-light1: #d9d9d9;
  --grey-light2: #f4f4f4;
  --grey-light3: #f0f0f0;
  --grey-light4: rgb(245 242 255);
  --black-100: #000000;
  --black-15: rbga(0, 0, 0, 0.15); }

.ant-collapse {
  background-color: transparent;
  border: none;
  overflow: hidden; }
  .ant-collapse .ant-collapse-item {
    margin-bottom: 4px;
    border: 1px solid var(--grey-light1);
    overflow: hidden; }
    .ant-collapse .ant-collapse-item .ant-collapse-header {
      background-color: transparent;
      border: 1px solid transparent; }
      .ant-collapse .ant-collapse-item .ant-collapse-header:hover {
        background-color: var(--secondary-10);
        border: 1px solid var(--secondary-40); }

.ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 10px 10px; }

.accordion-table .ant-table-content {
  border: 1px solid var(--grey-light2);
  border-radius: 4px;
  overflow: hidden; }
  .accordion-table .ant-table-content table tr th {
    font-weight: 600; }
    .accordion-table .ant-table-content table tr th::before {
      content: none !important; }
  .accordion-table .ant-table-content table tr .ant-table-cell {
    border: 1px solid var(--grey-light2); }
    .accordion-table .ant-table-content table tr .ant-table-cell:first-child {
      width: 30%; }
    .accordion-table .ant-table-content table tr .ant-table-cell:nth-child(2) {
      width: 25%; }
    .accordion-table .ant-table-content table tr .ant-table-cell:last-child {
      text-align: right; }

:root {
  --primary-100: rgb(11, 71, 254);
  --primary-90: rgba(11, 71, 254, 90%);
  --primary-80: rgba(11, 71, 254, 80%);
  --primary-70: rgba(11, 71, 254, 70%);
  --primary-60: rgba(11, 71, 254, 60%);
  --primary-50: rgba(11, 71, 254, 50%);
  --primary-40: rgba(11, 71, 254, 40%);
  --primary-30: rgba(11, 71, 254, 30%);
  --primary-20: rgba(11, 71, 254, 20%);
  --primary-10: rgba(11, 71, 254, 10%);
  --primary-05: rgba(11, 71, 254, 5%);
  --secondary-100: rgb(53, 0, 183);
  --secondary-90: rgba(53, 0, 183, 90%);
  --secondary-80: rgba(53, 0, 183, 80%);
  --secondary-70: rgba(53, 0, 183, 70%);
  --secondary-60: rgba(53, 0, 183, 60%);
  --secondary-50: rgba(53, 0, 183, 50%);
  --secondary-40: rgba(53, 0, 183, 40%);
  --secondary-30: rgba(53, 0, 183, 30%);
  --secondary-20: rgba(53, 0, 183, 20%);
  --secondary-10: rgba(53, 0, 183, 10%);
  --secondary-05: rgba(53, 0, 183, 5%);
  --white: #ffffff;
  --white-80: rgba(255, 255, 255, 0.8);
  --white-60: rgba(255, 255, 255, 0.6);
  --black: #000000;
  --black-10: #525252;
  --text-1: #1a1a1a;
  --text-2: #a1a1a1;
  --grey-light1: #d9d9d9;
  --grey-light2: #f4f4f4;
  --grey-light3: #f0f0f0;
  --grey-light4: rgb(245 242 255);
  --black-100: #000000;
  --black-15: rbga(0, 0, 0, 0.15); }

.ant-picker.ant-picker-range {
  padding: 4px 12px 4px 0; }
  .ant-picker.ant-picker-range .ant-picker-input input {
    text-align: center; }
  .ant-picker.ant-picker-range.ant-picker-focused .ant-picker-active-bar {
    margin-left: 0;
    height: 100%;
    bottom: 0;
    opacity: 0.2; }

.ant-picker-dropdown .ant-picker-range-wrapper .ant-picker-panel-container {
  display: flex;
  flex-direction: row-reverse; }
  .ant-picker-dropdown .ant-picker-range-wrapper .ant-picker-panel-container .ant-picker-footer {
    min-width: 120px;
    border-right: 1px solid var(--grey-light1); }
    .ant-picker-dropdown .ant-picker-range-wrapper .ant-picker-panel-container .ant-picker-footer .ant-picker-ranges {
      padding: 0; }
      .ant-picker-dropdown .ant-picker-range-wrapper .ant-picker-panel-container .ant-picker-footer .ant-picker-ranges .ant-picker-preset {
        display: block;
        border-bottom: 1px solid var(--grey-light1); }
        .ant-picker-dropdown .ant-picker-range-wrapper .ant-picker-panel-container .ant-picker-footer .ant-picker-ranges .ant-picker-preset .ant-tag {
          padding: 12px 10px;
          display: block;
          font-size: 14px;
          font-weight: 500;
          line-height: normal;
          color: var(--text-1);
          background: transparent;
          border: none;
          margin: 0; }
          .ant-picker-dropdown .ant-picker-range-wrapper .ant-picker-panel-container .ant-picker-footer .ant-picker-ranges .ant-picker-preset .ant-tag:hover {
            background-color: var(--grey-light4);
            color: var(--primary-100); }

:root {
  --primary-100: rgb(11, 71, 254);
  --primary-90: rgba(11, 71, 254, 90%);
  --primary-80: rgba(11, 71, 254, 80%);
  --primary-70: rgba(11, 71, 254, 70%);
  --primary-60: rgba(11, 71, 254, 60%);
  --primary-50: rgba(11, 71, 254, 50%);
  --primary-40: rgba(11, 71, 254, 40%);
  --primary-30: rgba(11, 71, 254, 30%);
  --primary-20: rgba(11, 71, 254, 20%);
  --primary-10: rgba(11, 71, 254, 10%);
  --primary-05: rgba(11, 71, 254, 5%);
  --secondary-100: rgb(53, 0, 183);
  --secondary-90: rgba(53, 0, 183, 90%);
  --secondary-80: rgba(53, 0, 183, 80%);
  --secondary-70: rgba(53, 0, 183, 70%);
  --secondary-60: rgba(53, 0, 183, 60%);
  --secondary-50: rgba(53, 0, 183, 50%);
  --secondary-40: rgba(53, 0, 183, 40%);
  --secondary-30: rgba(53, 0, 183, 30%);
  --secondary-20: rgba(53, 0, 183, 20%);
  --secondary-10: rgba(53, 0, 183, 10%);
  --secondary-05: rgba(53, 0, 183, 5%);
  --white: #ffffff;
  --white-80: rgba(255, 255, 255, 0.8);
  --white-60: rgba(255, 255, 255, 0.6);
  --black: #000000;
  --black-10: #525252;
  --text-1: #1a1a1a;
  --text-2: #a1a1a1;
  --grey-light1: #d9d9d9;
  --grey-light2: #f4f4f4;
  --grey-light3: #f0f0f0;
  --grey-light4: rgb(245 242 255);
  --black-100: #000000;
  --black-15: rbga(0, 0, 0, 0.15); }

.ant-switch {
  background-color: var(--primary-100); }

.ant-popover {
  padding: 4px;
  width: 100%;
  max-width: 250px; }
  .ant-popover .ant-popover-content .ant-popover-arrow {
    display: none; }
  .ant-popover .ant-popover-content .ant-popover-inner {
    border-radius: 6px; }

.ant-drawer-content-wrapper {
  max-width: 450px;
  width: 100% !important; }

.ant-drawer-header-title {
  flex-direction: row-reverse;
  justify-content: space-between; }
  .ant-drawer-header-title .ant-drawer-close {
    margin: 0 0 0 12px; }

* {
  font-family: 'Nunito Sans', sans-serif;
  box-sizing: border-box; }

html {
  height: -webkit-fill-available;
  height: -webkit-fill-available;
  height: fill-available; }

body {
  margin: 0;
  padding: 0;
  font-family: 'Nunito Sans', sans-serif !important;
  color: var(--text-1);
  background: var(--primary-bg-1) !important;
  overflow-x: hidden;
  height: -webkit-fill-available;
  height: -webkit-fill-available;
  height: fill-available; }

html,
body,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline; }

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block; }

a {
  text-decoration: none;
  outline: none;
  cursor: pointer; }

p {
  margin: 0;
  word-break: break-word; }

ol,
ul {
  list-style: none; }

blockquote,
q {
  quotes: none; }

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none; }

table {
  border-collapse: collapse;
  border-spacing: 0; }

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  padding: 0;
  outline: none;
  color: var(--text-1); }

button {
  outline: none;
  cursor: pointer;
  outline-color: transparent;
  appearance: none; }

button:focus,
button > .focus {
  outline: none;
  box-shadow: none;
  cursor: pointer; }

.list-disc {
  list-style: disc; }

.resize-none {
  resize: none; }

.flex-1 {
  flex: 1 1; }

.cursor-pointer {
  cursor: pointer; }

.ant-select-clear, .ant-input-clear-icon {
  top: 0;
  bottom: 0;
  margin: auto 0; }
  .ant-select-clear .anticon-close-circle, .ant-input-clear-icon .anticon-close-circle {
    vertical-align: unset; }

:root {
  --primary-100: rgb(11, 71, 254);
  --primary-90: rgba(11, 71, 254, 90%);
  --primary-80: rgba(11, 71, 254, 80%);
  --primary-70: rgba(11, 71, 254, 70%);
  --primary-60: rgba(11, 71, 254, 60%);
  --primary-50: rgba(11, 71, 254, 50%);
  --primary-40: rgba(11, 71, 254, 40%);
  --primary-30: rgba(11, 71, 254, 30%);
  --primary-20: rgba(11, 71, 254, 20%);
  --primary-10: rgba(11, 71, 254, 10%);
  --primary-05: rgba(11, 71, 254, 5%);
  --secondary-100: rgb(53, 0, 183);
  --secondary-90: rgba(53, 0, 183, 90%);
  --secondary-80: rgba(53, 0, 183, 80%);
  --secondary-70: rgba(53, 0, 183, 70%);
  --secondary-60: rgba(53, 0, 183, 60%);
  --secondary-50: rgba(53, 0, 183, 50%);
  --secondary-40: rgba(53, 0, 183, 40%);
  --secondary-30: rgba(53, 0, 183, 30%);
  --secondary-20: rgba(53, 0, 183, 20%);
  --secondary-10: rgba(53, 0, 183, 10%);
  --secondary-05: rgba(53, 0, 183, 5%);
  --white: #ffffff;
  --white-80: rgba(255, 255, 255, 0.8);
  --white-60: rgba(255, 255, 255, 0.6);
  --black: #000000;
  --black-10: #525252;
  --text-1: #1a1a1a;
  --text-2: #a1a1a1;
  --grey-light1: #d9d9d9;
  --grey-light2: #f4f4f4;
  --grey-light3: #f0f0f0;
  --grey-light4: rgb(245 242 255);
  --black-100: #000000;
  --black-15: rbga(0, 0, 0, 0.15); }

.f-8 {
  font-size: 8px !important; }

.f-12 {
  font-size: 12px !important; }

.f-14 {
  font-size: 14px !important; }

.f-16 {
  font-size: 16px !important; }

.f-20 {
  font-size: 20px !important; }

.f-24 {
  font-size: 24px !important; }

.f-32 {
  font-size: 32px !important; }

.f-w-200 {
  font-weight: 200; }

.f-w-300 {
  font-weight: 300; }

.f-w-400 {
  font-weight: 400; }

.f-w-500 {
  font-weight: 500; }

.f-w-600 {
  font-weight: 600; }

.f-w-700 {
  font-weight: 700; }

.f-w-800 {
  font-weight: 800; }

.l-h-16 {
  line-height: 16px; }

.l-h-24 {
  line-height: 24px; }

.l-h-normal {
  line-height: normal; }

.max-w-200 {
  max-width: 200px; }

.max-w-250 {
  max-width: 250px; }

.max-w-300 {
  max-width: 300px; }

.max-w-500 {
  max-width: 500px; }

.txt-primary {
  color: var(--primary-100) !important; }

.txt-text-1 {
  color: var(--text-1) !important; }

.txt-text-2 {
  color: var(--text-2) !important; }

.txt-white {
  color: #fff !important; }

.txt-black {
  color: #000 !important; }

.p-2px {
  padding: 2px !important; }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/settings/_colors.scss","webpack://./src/assets/styles/material/_antd_accordion.scss","webpack://./src/assets/styles/material/_antd_table.scss","webpack://./src/assets/styles/material/_antd_datepicker.scss","webpack://./src/assets/styles/material/_ant_switch.scss","webpack://./src/assets/styles/material/_antd_popover.scss","webpack://./src/assets/styles/material/_antd_drawer.scss","webpack://./src/assets/styles/_custom.scss","webpack://./src/assets/styles/tools/_utilities.scss"],"names":[],"mappings":"AAAA;EACI,+BAAc;EACd,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,mCAAa;EAEb,gCAAgB;EAChB,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,oCAAe;EAEf,gBAAQ;EACR,oCAAW;EACX,oCAAW;EACX,gBAAQ;EACR,mBAAW;EAEX,iBAAS;EACT,iBAAS;EAET,sBAAc;EACd,sBAAc;EACd,sBAAc;EACd,+BAAc;EAEd,oBAAY;EACZ,+BAAW,EAAA;;ACxCf;EACI,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB,EAAA;EAHpB;IAKQ,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB,EAAA;IAPxB;MASY,6BAA6B;MAC7B,6BAA6B,EAAA;MAVzC;QAYgB,qCAAqC;QACrC,qCAAqC,EAAA;;AAMrD;EACI,4BAA4B,EAAA;;ACpBhC;EAEQ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB,EAAA;EAJxB;IAQoB,gBAAgB,EAAA;IARpC;MAUwB,wBAAwB,EAAA;EAVhD;IAcoB,oCAAoC,EAAA;IAdxD;MAgBwB,UAAU,EAAA;IAhBlC;MAmBwB,UAAU,EAAA;IAnBlC;MAsBwB,iBAAiB,EAAA;;AFtBzC;EACI,+BAAc;EACd,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,mCAAa;EAEb,gCAAgB;EAChB,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,oCAAe;EAEf,gBAAQ;EACR,oCAAW;EACX,oCAAW;EACX,gBAAQ;EACR,mBAAW;EAEX,iBAAS;EACT,iBAAS;EAET,sBAAc;EACd,sBAAc;EACd,sBAAc;EACd,+BAAc;EAEd,oBAAY;EACZ,+BAAW,EAAA;;AGtCf;EAEQ,uBAAuB,EAAA;EAF/B;IAKgB,kBAAkB,EAAA;EALlC;IAUgB,cAAc;IACd,YAAY;IACZ,SAAS;IACT,YAAY,EAAA;;AAM5B;EAGY,aAAa;EACb,2BAA2B,EAAA;EAJvC;IAMgB,gBAAgB;IAChB,0CAA0C,EAAA;IAP1D;MASoB,UAAU,EAAA;MAT9B;QAWwB,cAAc;QACd,2CAA2C,EAAA;QAZnE;UAc4B,kBAAkB;UAClB,cAAc;UACd,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,oBAAoB;UACpB,uBAAuB;UACvB,YAAY;UACZ,SAAS,EAAA;UAtBrC;YAwBgC,oCAAoC;YACpC,yBAAyB,EAAA;;AH9CzD;EACI,+BAAc;EACd,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,mCAAa;EAEb,gCAAgB;EAChB,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,oCAAe;EAEf,gBAAQ;EACR,oCAAW;EACX,oCAAW;EACX,gBAAQ;EACR,mBAAW;EAEX,iBAAS;EACT,iBAAS;EAET,sBAAc;EACd,sBAAc;EACd,sBAAc;EACd,+BAAc;EAEd,oBAAY;EACZ,+BAAW,EAAA;;AItCf;EACI,oCAAoC,EAAA;;ACHxC;EACI,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAA;EAHpB;IAOY,aAAa,EAAA;EAPzB;IAWY,kBAAkB,EAAA;;ACX9B;EACI,gBAAgB;EAChB,sBAAsB,EAAA;;AAG1B;EACI,2BAA2B;EAC3B,8BAA8B,EAAA;EAFlC;IAKQ,kBAAkB,EAAA;;ACV1B;EACI,sCAAsC;EACtC,sBAAsB,EAAA;;AAGxB;EACE,8BAA8B;EAE9B,8BAA8B;EAC9B,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,UAAU;EACV,iDAAiD;EACjD,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAE9B,8BAA8B;EAC9B,sBAAsB,EAAA;;AAGxB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,wBAAwB,EAAA;;AAE1B;;;;;;;;;;;EAWE,cAAc,EAAA;;AAEhB;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe,EAAA;;AAEjB;EACE,SAAS;EACT,sBAAsB,EAAA;;AAExB;;EAEE,gBAAgB,EAAA;;AAElB;;EAEE,YAAY,EAAA;;AAEd;;;;EAIE,WAAW;EACX,aAAa,EAAA;;AAEf;EACE,yBAAyB;EACzB,iBAAiB,EAAA;;AAEnB;;;;;;EAME,SAAS;EACT,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,gBAAgB,EAAA;;AAElB;;EAEE,aAAa;EACb,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;;AAMhB;EACE,YAAY,EAAA;;AAIhB;EACE,SAAO,EAAA;;AAIP;EACE,eAAe,EAAA;;AAInB;EACE,MAAM;EACN,SAAS;EACT,cAAc,EAAA;EAHhB;IAKI,qBAAqB,EAAA;;AP/M3B;EACI,+BAAc;EACd,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,oCAAa;EACb,mCAAa;EAEb,gCAAgB;EAChB,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,qCAAe;EACf,oCAAe;EAEf,gBAAQ;EACR,oCAAW;EACX,oCAAW;EACX,gBAAQ;EACR,mBAAW;EAEX,iBAAS;EACT,iBAAS;EAET,sBAAc;EACd,sBAAc;EACd,sBAAc;EACd,+BAAc;EAEd,oBAAY;EACZ,+BAAW,EAAA;;AQlCb;EACE,yBAA0C,EAAA;;AAD5C;EACE,0BAA0C,EAAA;;AAD5C;EACE,0BAA0C,EAAA;;AAD5C;EACE,0BAA0C,EAAA;;AAD5C;EACE,0BAA0C,EAAA;;AAD5C;EACE,0BAA0C,EAAA;;AAD5C;EACE,0BAA0C,EAAA;;AAQ5C;EACE,gBAJkB,EAAA;;AAGpB;EACE,gBAJuB,EAAA;;AAGzB;EACE,gBAJ4B,EAAA;;AAG9B;EACE,gBAJiC,EAAA;;AAGnC;EACE,gBAJsC,EAAA;;AAGxC;EACE,gBAJ2C,EAAA;;AAG7C;EACE,gBAJgD,EAAA;;AAYlD;EACE,iBAAa,EAAA;;AADf;EACE,iBAAa,EAAA;;AAKf;EACE,mBAAmB,EAAA;;AAKrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAQlB;EACE,oCAAgC,EAAA;;AADlC;EACE,+BAAgC,EAAA;;AADlC;EACE,+BAAgC,EAAA;;AADlC;EACE,sBAAgC,EAAA;;AADlC;EACE,sBAAgC,EAAA;;AAIpC;EACE,uBAAuB,EAAA","sourcesContent":[":root {\n    --primary-100: rgb(11, 71, 254);\n    --primary-90: rgba(11, 71, 254, 90%);\n    --primary-80: rgba(11, 71, 254, 80%);\n    --primary-70: rgba(11, 71, 254, 70%);\n    --primary-60: rgba(11, 71, 254, 60%);\n    --primary-50: rgba(11, 71, 254, 50%);\n    --primary-40: rgba(11, 71, 254, 40%);\n    --primary-30: rgba(11, 71, 254, 30%);\n    --primary-20: rgba(11, 71, 254, 20%);\n    --primary-10: rgba(11, 71, 254, 10%);\n    --primary-05: rgba(11, 71, 254, 5%);\n\n    --secondary-100: rgb(53, 0, 183);\n    --secondary-90: rgba(53, 0, 183, 90%);\n    --secondary-80: rgba(53, 0, 183, 80%);\n    --secondary-70: rgba(53, 0, 183, 70%);\n    --secondary-60: rgba(53, 0, 183, 60%);\n    --secondary-50: rgba(53, 0, 183, 50%);\n    --secondary-40: rgba(53, 0, 183, 40%);\n    --secondary-30: rgba(53, 0, 183, 30%);\n    --secondary-20: rgba(53, 0, 183, 20%);\n    --secondary-10: rgba(53, 0, 183, 10%);\n    --secondary-05: rgba(53, 0, 183, 5%);\n\n    --white: #ffffff;\n    --white-80: rgba(255, 255, 255, 0.8);\n    --white-60: rgba(255, 255, 255, 0.6);\n    --black: #000000;\n    --black-10: #525252;\n    \n    --text-1: #1a1a1a;\n    --text-2: #a1a1a1;\n\n    --grey-light1: #d9d9d9;\n    --grey-light2: #f4f4f4;\n    --grey-light3: #f0f0f0;\n    --grey-light4: rgb(245 242 255);\n\n    --black-100: #000000;\n    --black-15: rbga(0, 0, 0, 0.15);\n}\n",".ant-collapse {\n    background-color: transparent;\n    border: none;\n    overflow: hidden;\n    .ant-collapse-item {\n        margin-bottom: 4px;\n        border: 1px solid var(--grey-light1);\n        overflow: hidden;\n        .ant-collapse-header {\n            background-color: transparent;\n            border: 1px solid transparent;\n            &:hover {\n                background-color: var(--secondary-10);\n                border: 1px solid var(--secondary-40);\n            }\n        }\n    }\n}\n\n.ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {\n    border-radius: 0 0 10px 10px;\n}",".accordion-table {\n    .ant-table-content {\n        border: 1px solid var(--grey-light2);\n        border-radius: 4px;\n        overflow: hidden;\n        table {\n            tr {\n                th {\n                    font-weight: 600;\n                    &::before {\n                        content: none !important;\n                    }\n                }\n                .ant-table-cell {\n                    border: 1px solid var(--grey-light2);\n                    &:first-child {\n                        width: 30%;\n                    }\n                    &:nth-child(2) {\n                        width: 25%;\n                    }\n                    &:last-child {\n                        text-align: right;\n                    }\n                }\n            }\n        }\n    }\n}","@import '../settings/colors';\n\n.ant-picker {\n    &.ant-picker-range {\n        padding: 4px 12px 4px 0;\n        .ant-picker-input {\n            input {\n                text-align: center;\n            }\n        }\n        &.ant-picker-focused {\n            .ant-picker-active-bar {\n                margin-left: 0;\n                height: 100%;\n                bottom: 0;\n                opacity: 0.2;\n            }\n        }\n    }\n}\n\n.ant-picker-dropdown {\n    .ant-picker-range-wrapper {\n        .ant-picker-panel-container {\n            display: flex;\n            flex-direction: row-reverse;\n            .ant-picker-footer {\n                min-width: 120px;\n                border-right: 1px solid var(--grey-light1);\n                .ant-picker-ranges {\n                    padding: 0;\n                    .ant-picker-preset {\n                        display: block;\n                        border-bottom: 1px solid var(--grey-light1);\n                        .ant-tag {\n                            padding: 12px 10px;\n                            display: block;\n                            font-size: 14px;\n                            font-weight: 500;\n                            line-height: normal;\n                            color: var(--text-1);\n                            background: transparent;\n                            border: none;\n                            margin: 0;\n                            &:hover {\n                                background-color: var(--grey-light4);\n                                color: var(--primary-100);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","@import '../settings/colors';\n\n.ant-switch {\n    background-color: var(--primary-100);\n}",".ant-popover {\n    padding: 4px;\n    width: 100%;\n    max-width: 250px;\n\n    .ant-popover-content {\n        .ant-popover-arrow {\n            display: none;\n        }\n\n        .ant-popover-inner {\n            border-radius: 6px;\n        }\n    }\n}",".ant-drawer-content-wrapper {\n    max-width: 450px;\n    width: 100% !important;\n}\n\n.ant-drawer-header-title {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n\n    .ant-drawer-close {\n        margin: 0 0 0 12px;\n    }\n}","* {\n    font-family: 'Nunito Sans', sans-serif;\n    box-sizing: border-box;\n  }\n  \n  html {\n    height: -webkit-fill-available;\n    height: -moz-available;\n    height: -webkit-fill-available;\n    height: fill-available;\n  }\n  \n  body {\n    margin: 0;\n    padding: 0;\n    font-family: 'Nunito Sans', sans-serif !important;\n    color: var(--text-1);\n    background: var(--primary-bg-1) !important;\n    overflow-x: hidden;\n    height: -webkit-fill-available;\n    height: -moz-available;\n    height: -webkit-fill-available;\n    height: fill-available;\n  }\n  \n  html,\n  body,\n  span,\n  applet,\n  object,\n  iframe,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  blockquote,\n  pre,\n  a,\n  abbr,\n  acronym,\n  address,\n  big,\n  cite,\n  code,\n  del,\n  dfn,\n  em,\n  img,\n  ins,\n  kbd,\n  q,\n  s,\n  samp,\n  small,\n  strike,\n  strong,\n  sub,\n  sup,\n  tt,\n  var,\n  b,\n  u,\n  i,\n  center,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  article,\n  aside,\n  canvas,\n  details,\n  embed,\n  figure,\n  figcaption,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  output,\n  ruby,\n  section,\n  summary,\n  time,\n  mark,\n  audio,\n  video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  section {\n    display: block;\n  }\n  a {\n    text-decoration: none;\n    outline: none;\n    cursor: pointer;\n  }\n  p {\n    margin: 0;\n    word-break: break-word;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: \"\";\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 0;\n    margin-inline-start: 0;\n    margin-inline-end: 0;\n    margin-block-start: 0;\n    margin-block-end: 0;\n    padding: 0;\n    outline: none;\n    color: var(--text-1);\n  }\n  \n  button {\n    outline: none;\n    cursor: pointer;\n    outline-color: transparent;\n    appearance: none;\n  }\n  button:focus,\n  button > .focus {\n    outline: none;\n    box-shadow: none;\n    cursor: pointer;\n  }\n  \n  .list-disc {\n    list-style: disc;\n  }\n  \n  //resize property styles\n  \n  .resize {\n    &-none {\n      resize: none;\n    }\n  }\n\n  .flex-1 {\n    flex: 1;\n  }\n\n  .cursor {\n    &-pointer {\n      cursor: pointer;\n    }\n  }\n  \n  .ant-select-clear, .ant-input-clear-icon {\n    top: 0;\n    bottom: 0;\n    margin: auto 0;\n    .anticon-close-circle {\n      vertical-align: unset;\n    }\n  }","@import '../settings/colors';\n\n//Font Size\n$fontSizeConfig: 8, 12, 14, 16, 20, 24, 32;\n\n@each $font in $fontSizeConfig {\n  .f-#{nth($font, 1)} {\n    font-size: #{nth($font, 1)}px !important;\n  }\n}\n\n//Font-weight\n$fontWeightConfig: 200, 300, 400, 500, 600, 700, 800;\n\n@each $weight in $fontWeightConfig {\n  .f-w-#{$weight} {\n    font-weight: $weight;\n  }\n}\n\n//Line-height\n$lineHeightConfig: 16, 24;\n\n@each $height in $lineHeightConfig {\n  .l-h-#{nth($height, 1)} {\n    line-height: #{nth($height, 1)}px;\n  }\n}\n\n.l-h {\n  &-normal {\n    line-height: normal;\n  }\n}\n\n.max-w {\n  &-200 {\n    max-width: 200px;\n  }\n\n  &-250 {\n    max-width: 250px;\n  }\n\n  &-300 {\n    max-width: 300px;\n  }\n\n  &-500 {\n    max-width: 500px;\n  }\n}\n\n// color\n$textColors: 'primary' var(--primary-100), 'text-1' var(--text-1), 'text-2' var(--text-2), \"white\" #fff, \"black\" #000;\n\n@each $color in $textColors {\n  .txt-#{nth($color, 1)} {\n    color: nth($color, 2) !important;\n  }\n}\n\n.p-2px {\n  padding: 2px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
